import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { nutritionGoalsData } from '__mocks__/mockData/nutrition-goals';

const NutritionGoalsApi = [
  rest.get(`${API_ROOT}nutrition-goals`, (req, res, ctx) => res(ctx.json(nutritionGoalsData))),
  rest.get(`${API_ROOT}nutrition-goals/${nutritionGoalsData[0].id}`, (req, res, ctx) => res(ctx.json(nutritionGoalsData[0]))),
  rest.delete(`${API_ROOT}nutrition-goals/${nutritionGoalsData[0].id}`, (req, res, ctx) => res(ctx.json(nutritionGoalsData[0]))),
  rest.put(`${API_ROOT}nutrition-goals/${nutritionGoalsData[0].id}`, (req, res, ctx) => res(ctx.json(nutritionGoalsData[0]))),
  rest.post(`${API_ROOT}nutrition-goals`, (req, res, ctx) => res(ctx.json({}))),
];
export default NutritionGoalsApi;
